import {IBalance} from "@/lib/types/wallet/IBalance";
import {ISocketBalance} from "@/lib/types/wallet/ISocketBalance";

/** WS values arrive as numbers or numeric strings; absent fields stay 0. */
const num = (value: number | string | undefined): number => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
};

/**
 * AC-798: maps one WS balance-push entry into the typed IBalance the RTK
 * cache holds. The push is camelCase (see NotificationGrpcService), NOT
 * snake_case — reading snake_case keys here produced NaN for every field
 * except `balance`, which the popover rendered as $0.00 after each in-game
 * balance push while the header (reading `balance`) stayed correct.
 *
 * The payload carries no `rate` — pass the previous cache entry so the
 * conversion rate for USD-denominated amounts survives balance pushes.
 */
export const mapSocketBalance = (socket: ISocketBalance, previous?: IBalance): IBalance => ({
    currency: socket.currency,
    balance: num(socket.balance),
    bonusBalance: num(socket.bonusBalance),
    bonusWageringProgress: num(socket.bonusWageringProgress),
    bonusWageringRequirement: num(socket.bonusWageringRequirement),
    realBalance: num(socket.realBalance),
    realWageringRequirement: num(socket.realWageringRequirement),
    rate: previous?.rate,
});
